import { EventEmitter, Injectable } from '@angular/core';
import { AuthEnum as AuthModalEnum } from './auth-modal.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn:"any"})
export class AuthModalService {
    step=new BehaviorSubject<AuthModalEnum>(AuthModalEnum.Login);
    onClose=new EventEmitter();
    
    authEnum = AuthModalEnum;
    isInModal = false;
    loginDescription?:string;
    


    constructor() { }
    goLogin() {
        this.step.next( AuthModalEnum.Login);
    }
    goSignUp() {
        this.step.next(AuthModalEnum.SignUp);
    }
   
    
    goForgetPassword() {
        this.step.next( AuthModalEnum.ForgetPassword);
    }
    goVerifyEmail() {
        this.step.next( AuthModalEnum.VerifyEmail);
    }
   
    
    close(){
        this.onClose.emit();
    }
}